<template>
    <div class="container-display" id='container-display'>
        <div class="viewZone">
            <div class="panel_for_toolbox">
                <select class="select_for_mobile" @change="chooseTool($event)" id="selectedTool">
                    <option value="" hidden>请 选 择 工 具......</option>
                    <option v-for="(item, index) in items" :key="index" :value="item.name">{{ item.title }}</option>
                </select>
            </div>
            <div class="view_for_toolbox">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StructuralToolbox',
}
</script>

<script setup>
import { reactive } from "vue";
// vue3中使用vue-router
import { useRouter } from "vue-router";
const router = useRouter();

const items = reactive([
    {
        // name必须与index.js中的name一致
        title: "材料强度查询",
        name: "Material_Strength",
        primaryActive: " ",
        secondaryActive: false,
        secondaryLists: [],
    },
    {
        title: "基本风压、基本雪压查询",
        name: "Wind_Snow",
        primaryActive: " ",
        secondaryActive: false,
        secondaryLists: [],
    },
    {
        title: "地震动参数查询",
        name: "Seismic_Parameters",
        primaryActive: " ",
        secondaryActive: false,
        secondaryLists: [],
    },
]);

// function Change(name) {
//     items.forEach((item) => {
//         if (item.secondaryLists.length > 0) {
//             if (item.name === name) {
//                 item.secondaryActive = !item.secondaryActive;
//                 // if (item.secondaryActive === false) {
//                 //   item.iconMore = "iconfont icon-chevron_left";
//                 // } else {
//                 //   item.iconMore = "iconfont icon-chevron_down";
//                 // }
//             }
//             if (item.name !== name && item.secondaryActive === true) {
//                 item.secondaryActive = !item.secondaryActive;
//                 // item.iconMore = "iconfont icon-chevron_left";
//             }
//         } else {
//             if (item.name === name) {
//                 item.primaryActive = "active";
//                 router.push({ name: name });
//             }
//             if (item.name !== name) {
//                 item.primaryActive = " ";
//             }
//         }
//     });
// }
function chooseTool(e) {
    let select = e.target;
    let i = select.selectedIndex; // selectedIndex代表的是你所选中项的index。
    let name = select.options[i].value;
    if (name !== "") {
        router.push({ name: name });
    }
}
</script>

<style scoped>
.container-display {
    background-color: rgb(242, 241, 241);
    width: 100%;
    height: calc(100% - 60px);
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    justify-items: center;
    align-items: center;

}




/* 展示区内的样式～～～～～～～～～～～～～～～～～～～～～～～～～～～ */
.viewZone {
    background-color: white;
    /* width: calc(100% - var(--secondary-panel-of-toolbox-width) - 2*6px); */
    width: 35vw;
    height: 75vh;
    min-width: 450px;
    max-width: 600px;
    /* min-height: 620px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* display: grid; */
    /* grid-template-columns: 1fr;
    grid-template-rows: 120px 1fr; */
    justify-items: center;
    align-items: center;
    box-shadow: 5px 7px 5px rgba(49, 47, 47, 0.5), -5px -7px 5px rgba(198, 193, 193, 0.5);
    border-radius: 10px 10px 10px 10px;
    background-image: url("../assets/imgs/logo.png");
    background-repeat: no-repeat;
    background-size: 250px 250px;
    background-position: center;
    overflow: hidden;
}

.viewZone * {
    box-sizing: border-box;
}


.panel_for_toolbox {
    height: 45px;
    width: 75%;
    padding: 0px 20px;
    border: 1px solid var(--secondary-color);
    border-radius: 25px;
    margin: 45px;
    display: flex;
    justify-content: center;

    box-shadow: 6px 6px 3px rgba(0, 0, 0, 0.3), -4px -4px 4px rgba(194, 185, 185, 0.4);
    padding-left: 20px;
}


.select_for_mobile {
    width: 90%;
    height: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    background-color: white;
    /* padding: 0px 20px; */
    /* text-align: center; */
}

.view_for_toolbox {
    border-top: 1px solid #e1dddd;
    width: 100%;
    height: calc(100% - 135px);
    background-color: rgba(255, 255, 255, 0.5);
    /* 白色背景，50% 透明度 */

}



@media (orientation: portrait) and (max-width: 768px) {

    .viewZone {
        width: 100%;
        height: 100%;
        grid-template-rows: 80px 1fr;
    }

    .panel_for_toolbox {
        margin-top: 40px;
    }

    .view_for_toolbox {
        width: 100%;
        height: calc(100% - 150px);
    }
}
</style>